import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Twitter, Youtube, MapPin, Mail, ShieldCheck } from 'lucide-react';
import { LogoLight } from './Logo';
import { useLanguage } from '../lib/LanguageContext';

export default function SiteFooter() {
  const { t } = useLanguage();

  const columns = [
    {
      title: t('footer.colBrand'),
      links: [
        { l: t('footer.about'), to: '/a-propos' },
        { l: t('footer.careers'), to: '/a-propos#carrieres' },
        { l: t('footer.press'), to: '/a-propos#presse' },
        { l: t('footer.innovation'), to: '/a-propos#innovation' },
      ],
    },
    {
      title: t('footer.colIndividuals'),
      links: [
        { l: t('nav.accounts'), to: '/comptes' },
        { l: t('nav.cards'), to: '/cartes' },
        { l: t('nav.credits'), to: '/credits' },
        { l: t('nav.insurance'), to: '/assurances' },
        { l: t('nav.stock'), to: '/bourse' },
      ],
    },
    {
      title: t('footer.colPros'),
      links: [
        { l: t('footer.proSpace'), to: '/professionnels' },
        { l: t('footer.autoEntrepreneurs'), to: '/professionnels#auto' },
        { l: t('footer.tpePme'), to: '/professionnels#tpe' },
        { l: t('footer.bigCompanies'), to: '/professionnels#corp' },
        { l: t('footer.associations'), to: '/professionnels#asso' },
      ],
    },
    {
      title: t('footer.colSupport'),
      links: [
        { l: t('nav.help'), to: '/aide' },
        { l: t('footer.contactUs'), to: '/aide#contact' },
        { l: t('landing.faq'), to: '/aide#faq' },
        { l: t('footer.fileClaim'), to: '/aide#reclamation' },
        { l: t('footer.accessibility'), to: '/aide#accessibilite' },
      ],
    },
    {
      title: t('footer.colLegal'),
      links: [
        { l: t('footer.mentionsLegales'), to: '/mentions-legales' },
        { l: t('footer.cgu'), to: '/cgu' },
        { l: t('footer.confidentialite'), to: '/confidentialite' },
        { l: t('footer.cookies'), to: '/cookies' },
        { l: t('footer.rgpd'), to: '/rgpd' },
        { l: t('footer.sitemap'), to: '/plan-du-site' },
      ],
    },
  ];

  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex">
              <LogoLight size={44} />
            </Link>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              {t('footer.brandDesc')}
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-slate-700 flex items-center justify-center"><Facebook className="w-4 h-4"/></a>
              <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-slate-700 flex items-center justify-center"><Twitter className="w-4 h-4"/></a>
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-slate-700 flex items-center justify-center"><Linkedin className="w-4 h-4"/></a>
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-slate-700 flex items-center justify-center"><Instagram className="w-4 h-4"/></a>
              <a href="#" aria-label="YouTube" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-slate-700 flex items-center justify-center"><Youtube className="w-4 h-4"/></a>
            </div>
          </div>

          {columns.map((c) => (
            <div key={c.title}>
              <div className="font-semibold text-white mb-3 text-sm uppercase tracking-wider">{c.title}</div>
              <ul className="space-y-2 text-sm">
                {c.links.map((it) => (
                  <li key={it.l}><Link to={it.to} className="hover:text-white">{it.l}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div className="mt-10 pt-8 border-t border-slate-800 grid md:grid-cols-2 gap-6 text-sm">
          <div className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5"/> contact@bfigroupefr.com</div>
          <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5"/> RTE CHABAN, 79180 CHAURAY, France</div>
        </div>

        {/* Trust */}
        <div className="mt-8 grid md:grid-cols-2 gap-4 text-xs text-slate-400">
          <div className="flex items-start gap-2"><ShieldCheck className="w-4 h-4 mt-0.5 text-emerald-500"/> {t('footer.depositGuarantee')}</div>
          <div>BFI Groupe S.A. à directoire au capital de 50 000 000 € • RCS Niort 401 380 472 • SIREN 401 380 472 • SIRET 401 380 472 00019 • N° TVA FR15401380472 • Code NAF 65.12Z • LEI 969500MO80IIJ5R0YR54.</div>
        </div>
      </div>
      <div className="border-t border-slate-800 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} BFI Groupe. {t('footer.copyright')}
      </div>
    </footer>
  );
}
